import React from "react";

var facebookSvg = function facebookSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4267B2",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.42 32V20.612h3.852l.575-4.458h-4.426v-2.838c0-1.29.361-2.163 2.213-2.163H26v-3.98A32.735 32.735 0 0 0 22.566 7c-3.404 0-5.725 2.072-5.725 5.874v3.28H13v4.458h3.841V32h4.58z"
  })));
};

facebookSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
};
export var facebook = {
  category: 'social',
  colorable: false,
  name: 'facebook',
  svg: facebookSvg
};